import { render, staticRenderFns } from "./AiBlocker.vue?vue&type=template&id=0f7be118&scoped=true&"
import script from "./AiBlocker.vue?vue&type=script&lang=js&"
export * from "./AiBlocker.vue?vue&type=script&lang=js&"
import style0 from "./AiBlocker.vue?vue&type=style&index=0&id=0f7be118&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7be118",
  null
  
)

export default component.exports